module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgurl
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('p', [_vm._v(_vm._s(_vm.text))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0d2d9353!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/footer/HomeFooterImg.vue
// module id = 136
// module chunks = 1